/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Edición completada',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Editar',
  'editor-common-extensibility.macro.button.configure': 'Configurar {macroName}',
  'editor.extension.legacyContentHeader': 'Contenido heredado',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Este contenido tiene funcionalidad limitada,',
  'editor.extension.legacyContentHeader.learnMore': 'Más información',
  'editor.trackChanges.toolbarIconLabel': 'Supervisar los cambios',
  'fablric.editor.viewAllInserts': 'Ver los elementos insertados',
  'fabric.editor.action': 'Elemento de acción',
  'fabric.editor.action.description': 'Crear y asignar elementos de acción',
  'fabric.editor.addAltText': 'Texto alternativo',
  'fabric.editor.addColumnLeft': 'Añadir columna a la izquierda',
  'fabric.editor.addColumnRight': 'Añadir columna a la derecha',
  'fabric.editor.addCommentOnMedia': 'Añadir comentario',
  'fabric.editor.addImageBorder': 'Añadir borde',
  'fabric.editor.addLoomVideo': 'Grabar un vídeo de Loom',
  'fabric.editor.addLoomVideoComment': 'Grabar un comentario de vídeo de Loom',
  'fabric.editor.addMediaFiles': 'Añadir imagen, vídeo o archivo',
  'fabric.editor.addRowAbove': 'Añadir fila arriba',
  'fabric.editor.addRowBelow': 'Añadir fila abajo',
  'fabric.editor.addUpdatedAltText': 'Añade texto alternativo',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Utiliza Atlassian Intelligence para buscar elementos de acción y mostrarlos en un panel',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Panel de elementos de acción (beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Utiliza Atlassian Intelligence para resumir esta página y mostrarla en un panel',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panel de resumen de página (beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Contenido seleccionado',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Genera contenido para insertarlo en la actualización.',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Resume el contenido de la actualización.',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generar',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Pregunta a Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Editar',
  'fabric.editor.ai.config.item.action.insert': 'Insertar',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Insertar arriba',
  'fabric.editor.ai.config.item.action.insertBelow': 'Insertar debajo',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Insertar debajo del original',
  'fabric.editor.ai.config.item.action.replace': 'Reemplazar',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Reemplazar título',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'El título no puede superar los {maxLength} caracteres',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Continuar en el chat',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Abrir en el chat',
  'fabric.editor.ai.config.item.addPolish.description': 'Pule el contenido para mejorarlo',
  'fabric.editor.ai.config.item.addPolish.title': 'Pulir',
  'fabric.editor.ai.config.item.agent.title': 'Agente Rovo de Atlassian Intelligence',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Acorta el contenido para hacerlo más conciso',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Reducir actualización',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Crea una descripción de la solicitud de extracción con un resumen de los cambios',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Crear descripción de la solicitud de extracción',
  'fabric.editor.ai.config.item.brainstorm.description': 'Genera una lista de ideas sobre un tema que propongas',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Háblame del tema...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Lluvia de ideas',
  'fabric.editor.ai.config.item.brainstorm.title': 'Lluvia de ideas',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Duración',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Ajustar longitud',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Cambia el tono del contenido a informal',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Informal',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Informal',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Cambiar el tono a informal',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Cambia el tono del contenido a educativo',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Educativo',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Educativo',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Cambiar el tono a educativo',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Cambia el tono del contenido a empático',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empático',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empático',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Cambia el tono a empático',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Cambia el tono a…',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Cambia el tono del contenido a neutro',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutro',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutro',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Cambia el tono a neutral',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Cambia el tono del contenido a profesional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Profesional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Profesional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Cambia el tono a profesional',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Reformatea el contenido en una lista con viñetas',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Convertir en lista con viñetas',
  'fabric.editor.ai.config.item.convertToTable.description': 'Reformatea el contenido a una tabla con encabezados.',
  'fabric.editor.ai.config.item.convertToTable.title': 'Convertir en tabla',
  'fabric.editor.ai.config.item.draftReply.description':
    'Redacta un borrador de una respuesta basada en incidencias similares a la incidencia en la que estás trabajando',
  'fabric.editor.ai.config.item.draftReply.title': 'Borrador de respuesta',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Corrige errores ortográficos y gramaticales',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Ortografía y la gramática',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Corregir la ortografía y la gramática',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Mejora la claridad, la estructura y el tono para facilitar la interacción y la comprensión',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Mejorar la redacción',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Mejorar la redacción',
  'fabric.editor.ai.config.item.findActionItems.description': 'Busca elementos de acción en el contenido que ofrezcas',
  'fabric.editor.ai.config.item.findActionItems.title': 'Buscar elementos de acción',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Selecciona una de las siguientes opciones (la generación libre está desactivada en Elevate en este momento)',
  'fabric.editor.ai.config.item.generateContent.promptHint':
    'Escribe con AI o selecciona una de las siguientes opciones',
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    'Genera notas de derivación según el contexto de la incidencia',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'Generar notas de derivación',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Reestructura la descripción de la incidencia en función del tipo de incidencia',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Mejorar la descripción',
  'fabric.editor.ai.config.item.makeLonger.description':
    'Amplía el contenido en función del contexto que proporciones.',
  'fabric.editor.ai.config.item.makeLonger.title': 'Ampliar',
  'fabric.editor.ai.config.item.range.agent.description': 'Sin descripción',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Pide al agente que escriba algo o elige una de las siguientes opciones',
  'fabric.editor.ai.config.item.rephrase.description': 'Crea una sugerencia para reescribir tus frases.',
  'fabric.editor.ai.config.item.rephrase.title': 'Reformular',
  'fabric.editor.ai.config.item.shorten.description': 'Acorta el contenido para hacerlo más conciso',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Acortar',
  'fabric.editor.ai.config.item.shorten.title': 'Acortar',
  'fabric.editor.ai.config.item.suggest.description': 'Sugiere un título para el contenido que ofrezcas',
  'fabric.editor.ai.config.item.suggest.title': 'Sugerir un título',
  'fabric.editor.ai.config.item.summarize.description':
    'Crea un resumen del texto en el que estás trabajando y destaca los puntos clave',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Resumir texto',
  'fabric.editor.ai.config.item.summarize.title': 'Resumir texto',
  'fabric.editor.ai.config.item.translate.czech': 'Checo',
  'fabric.editor.ai.config.item.translate.danish': 'Danés',
  'fabric.editor.ai.config.item.translate.dutch': 'Holandés',
  'fabric.editor.ai.config.item.translate.english': 'Inglés',
  'fabric.editor.ai.config.item.translate.finnish': 'Finlandés',
  'fabric.editor.ai.config.item.translate.french': 'Francés',
  'fabric.editor.ai.config.item.translate.german': 'Alemán',
  'fabric.editor.ai.config.item.translate.hungarian': 'Húngaro',
  'fabric.editor.ai.config.item.translate.italian': 'Italiano',
  'fabric.editor.ai.config.item.translate.japanese': 'Japonés',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Traducir',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Traducir a…',
  'fabric.editor.ai.config.item.translate.norwegian': 'Noruego',
  'fabric.editor.ai.config.item.translate.russian': 'Ruso',
  'fabric.editor.ai.config.item.translate.spanish': 'Español',
  'fabric.editor.ai.config.item.translate.swedish': 'Sueco',
  'fabric.editor.ai.config.item.translate.thai': 'Tailandés',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Traduce el texto en el que estás trabajando al chino (simplificado)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Traducir al chino (simplificado)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Traduce el texto en el que estás trabajando al chino (tradicional)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Traducir al chino (tradicional)',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Traduce el texto en el que estás trabajando al checo',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Traducir al checo',
  'fabric.editor.ai.config.item.translateTo.danish.description': 'Traduce el texto en el que estás trabajando al danés',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Traducir al danés',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Traduce el texto en el que estás trabajando al neerlandés',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Traducir al neerlandés',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Traduce el texto en el que estás trabajando al inglés',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Traducir al inglés',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Traduce el texto en el que estás trabajando al finés',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Traducir al finés',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Traduce el texto en el que estás trabajando al francés',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Traducir al francés',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Traduce el texto en el que estás trabajando al alemán',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Traducir al alemán',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Traduce el texto en el que estás trabajando al húngaro',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Traducir al húngaro',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Traduce el texto en el que estás trabajando al italiano',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Traducir al italiano',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Traduce el texto en el que estás trabajando al japonés',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Traducir al japonés',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Traduce el texto en el que estás trabajando al coreano',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Traducir al coreano',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Traduce el texto en el que estás trabajando al noruego',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Traducir al noruego',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Traduce el texto en el que estás trabajando al polaco',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Traducir al polaco',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Traduce el texto en el que estás trabajando al portugués (Brasil)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Traducir al portugués (Brasil)',
  'fabric.editor.ai.config.item.translateTo.russian.description': 'Traduce el texto en el que estás trabajando al ruso',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Traducir al ruso',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Traduce el texto en el que estás trabajando al español',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Traducir al español',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Traduce el texto en el que estás trabajando al sueco',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Traducir al sueco',
  'fabric.editor.ai.config.item.translateTo.thai.description':
    'Traduce el texto en el que estás trabajando al tailandés',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Traducir al tailandés',
  'fabric.editor.ai.config.item.translateTo.turkish.description':
    'Traduce el texto en el que estás trabajando al turco',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Traducir al turco',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Traduce el texto en el que estás trabajando al ucraniano',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Traducir al ucraniano',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Traduce el texto en el que estás trabajando al vietnamita',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Traducir al vietnamita',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Cambiar tono',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Reformular',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Traducir',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Título de página',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Página',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    'Tenemos problemas y no podemos generar una respuesta en este momento. Vuelve a intentarlo más tarde.',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Estamos teniendo problemas para insertar la respuesta. Cierra el diálogo e inténtalo de nuevo.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Estamos teniendo problemas para generar la vista previa. Cierra el diálogo e inténtalo de nuevo.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Hemos recibido demasiadas solicitudes recientes para Atlassian Intelligence (AI). Inténtalo de nuevo en unos minutos o infórmate sobre el <link>uso excesivo de AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'No hemos obtenido respuesta. Tu mensaje o respuesta han superado el límite de esta solicitud. Cierra el diálogo e inténtalo de nuevo.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Estamos teniendo problemas. Cierra el diálogo e inténtalo de nuevo.',
  'fabric.editor.ai.experience.adfStreamingError': 'Lo sentimos, no hemos recibido respuesta.',
  'fabric.editor.ai.experience.apiError': 'No hemos podido recibir una respuesta. Inténtalo de nuevo.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Es posible que tu mensaje o contenido no cumplan nuestra Política de uso aceptable. Revisa ambas y consulta nuestra <link>Política de uso aceptable</link> si es necesario. Si el problema continúa, plantéate la posibilidad de probar con un mensaje o contenido diferentes.',
  'fabric.editor.ai.experience.browseMore.agents': 'Buscar agentes',
  'fabric.editor.ai.experience.cmdPaletteApiError': 'Se ha producido un error al generar tu respuesta.',
  'fabric.editor.ai.experience.cmdPaletteAupViolationMessage':
    'No hemos podido completar la solicitud porque no cumple con nuestra <link>Política de uso aceptable</link>.',
  'fabric.editor.ai.experience.discardMessagePrompt': '¿Quieres descartar el mensaje?',
  'fabric.editor.ai.experience.discardMessageResponse': '¿Quieres descartar la respuesta?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': '¿Quieres cancelar la solicitud y descartar la respuesta?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'La generación libre está desactivada en Elevate en este momento.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Ahora puedes pegar los enlaces 🔗 al contenido de Jira y Confluence en tus indicaciones.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Con tecnología de Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Generando',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence no ha podido procesar tu solicitud porque tu contenido contiene enlaces a contenido restringido por la HIPAA. Elimina estos enlaces e inténtalo de nuevo.',
  'fabric.editor.ai.experience.inputTooShortError':
    'El contenido es demasiado corto para resumirlo. Añade más y vuelve a intentarlo.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) no responde. Inténtalo de nuevo más tarde o <link>consulta el estado de AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Generando',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analizando: tu pregunta está en revisión.',
  'fabric.editor.ai.experience.messageTemplateContentSearch':
    'Buscando: danos un momento en lo que buscamos la información.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Buscando: danos un momento mientras buscamos en Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Buscando: danos un momento mientras buscamos la página.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Sin resultados',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence no tiene ninguna sugerencia en este momento. Prueba con otro mensaje o contenido.',
  'fabric.editor.ai.experience.showMoreButton': 'Mostrar más',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Acciones',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agentes',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Fuente de conocimiento',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agentes de Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agentes Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Utiliza un Agente Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Usar conocimientos generales',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Usar los conocimientos de tu organización',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Estamos teniendo problemas para generar la vista previa. Cierra el diálogo e inténtalo de nuevo.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Estamos teniendo problemas. Cierra el diálogo e inténtalo de nuevo.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Insertar debajo',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Reemplazar',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Las solicitudes de generación de contenido que hacen referencia a las URL están en fase beta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Resaltar un término, una sigla o una abreviación',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definir',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': 'Definir',
  'fabric.editor.ai.toolbar.askAI.title': 'Preguntar a Atlassian Intelligence',
  'fabric.editor.ai.toolbar.askRovo.title': 'Preguntar a Rovo',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Preguntar a Rovo {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Preguntar a la IA de Rovo',
  'fabric.editor.ai.toolbar.changeTone.title': 'Cambiar tono',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'Cambia las opciones de tono',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Mejorar la redacción',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Pide a Atlassian Intelligence que mejore la redacción de tu selección',
  'fabric.editor.ai.toolbar.makeLonger.title': 'Ampliar',
  'fabric.editor.ai.toolbar.makeShorter.title': 'Acortar',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'Más casual',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'Más empático',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'Más profesional',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': 'Más opciones de Rovo',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': 'Corregir la ortografía y la gramática',
  'fabric.editor.ai.toolbar.summarize.title': 'Resumir',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': 'Traducir',
  'fabric.editor.ai.toolbar.translateOptions.label': 'Traducir opciones',
  'fabric.editor.ai.toolbar.tryAI.title': 'Probar AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Abrir Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Pregunta a Atlassian Intelligence {key}+'",
  'fabric.editor.alignCenter': 'Centrar',
  'fabric.editor.alignImageCenter': 'Centrar',
  'fabric.editor.alignImageLeft': 'Alinear a la izquierda',
  'fabric.editor.alignImageRight': 'Alinear a la derecha',
  'fabric.editor.alignLeft': 'Alinear a la izquierda',
  'fabric.editor.alignRight': 'Alinear a la derecha',
  'fabric.editor.alignTableCenter': 'Centrar',
  'fabric.editor.alignTableLeft': 'Alinear a la izquierda',
  'fabric.editor.alignment': 'Alineación de texto',
  'fabric.editor.altText': 'Texto alternativo',
  'fabric.editor.alttext.validation': 'Elimina los caracteres especiales en texto alternativo.',
  'fabric.editor.annotationToolbar': 'Barra de herramientas de anotaciones',
  'fabric.editor.backLink': 'Regresar',
  'fabric.editor.backgroundColor': 'Color de fondo',
  'fabric.editor.block.menu.codeblock': 'Bloque de código',
  'fabric.editor.block.menu.copy.block': 'Copiar bloque',
  'fabric.editor.block.menu.copy.link': 'Copiar enlace',
  'fabric.editor.block.menu.delete.block': 'Eliminar',
  'fabric.editor.block.menu.layout': 'Diseño',
  'fabric.editor.block.menu.move.down': 'Bajar',
  'fabric.editor.block.menu.move.up': 'Subir',
  'fabric.editor.block.menu.paragraph': 'Párrafo',
  'fabric.editor.blockCardUnavailable': 'El enlace insertado está dentro de {node} y no puede cambiar de vista',
  'fabric.editor.blockControlDelete': 'Eliminar',
  'fabric.editor.blockControlDragHandleMove': 'Arrastrar para mover',
  'fabric.editor.blockControlDragHandleRearrange': 'Arrastrar para reorganizar',
  'fabric.editor.blockControlInsert': 'Insertar',
  'fabric.editor.blockControlMoveDown': 'Bajar',
  'fabric.editor.blockControlMoveLeft': 'Mover a la izquierda',
  'fabric.editor.blockControlMoveRight': 'Mover a la derecha',
  'fabric.editor.blockControlMoveUp': 'Subir',
  'fabric.editor.blockControlMovedDown': 'El contenido se ha movido hacia abajo',
  'fabric.editor.blockControlMovedUp': 'El contenido se ha movido hacia arriba',
  'fabric.editor.blockDescription': 'Mostrar más información sobre un enlace, incluido un resumen y acciones',
  'fabric.editor.blockTitle': 'Tarjeta',
  'fabric.editor.blockquote': 'una cita',
  'fabric.editor.blockquote.description': 'Insertar una cita o referencia',
  'fabric.editor.blockquote2': 'Citar',
  'fabric.editor.bold': 'Negrita',
  'fabric.editor.breakout.resizeCodeBlock': 'Redimensionar el fragmento de código',
  'fabric.editor.breakout.resizeElement': 'Redimensionar el elemento',
  'fabric.editor.breakout.resizeExpand': 'Redimensiona la ampliación',
  'fabric.editor.breakout.resizeLayout': 'Redimensionar el diseño',
  'fabric.editor.breakoutFullWidthLabel': 'Anchura completa',
  'fabric.editor.breakoutWideWidthLabel': 'Ancho',
  'fabric.editor.bug': 'Error',
  'fabric.editor.bulletedList': 'Lista de viñetas',
  'fabric.editor.canNotSortTable': '⚠️ No puedes ordenar una tabla con celdas combinadas',
  'fabric.editor.cancelButton': 'Cancelar',
  'fabric.editor.captionPlaceholder': 'Añadir un subtítulo',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt':
    'Añade una leyenda: haz doble clic para obtener una vista previa',
  'fabric.editor.cardFloatingControls': 'Opciones de tarjeta',
  'fabric.editor.cellBackground': 'Fondo de celda',
  'fabric.editor.cellOptions': 'Opciones de celda',
  'fabric.editor.checkUncheckActionItem': 'Elemento de acción de alternancia',
  'fabric.editor.clearAltTextEdit': 'Borrar texto alternativo',
  'fabric.editor.clearCells': '{0, plural, one {Borrar celda} other {Borrar celdas}}',
  'fabric.editor.clearFormatting': 'Borrar formato',
  'fabric.editor.clearLink': 'Borrar enlace',
  'fabric.editor.clearLinkText': 'Borrar texto',
  'fabric.editor.closeAltTextEdit': 'Atrás',
  'fabric.editor.closeFindReplaceDialog': 'Cerrar',
  'fabric.editor.closeHelpDialog': 'Cerrar el diálogo de ayuda',
  'fabric.editor.code': 'Código',
  'fabric.editor.code.on': '{textFormattingOff}, código activado',
  'fabric.editor.codeBidiWarningLabel':
    'Los caracteres bidireccionales cambian el orden de renderización del texto. Esto podría utilizarse para ocultar código malicioso.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': '¡Copiado!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Copiar como texto',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Desactivar conclusión',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Activar conclusión',
  'fabric.editor.codeblock': 'Fragmento de código',
  'fabric.editor.codeblock.description': 'Mostrar código con resaltado de sintaxis',
  'fabric.editor.collapseNode': 'contraer contenido',
  'fabric.editor.collapseTable': 'Contraer tabla',
  'fabric.editor.colorPicker.menuLabel': 'Menú del selector de colores',
  'fabric.editor.columnDragHandle': 'Opciones de columna',
  'fabric.editor.columnMovedLeft': 'Columna movida a la izquierda a {index} de {total}',
  'fabric.editor.columnMovedRight': 'Columna movida a la derecha a {index} de {total}',
  'fabric.editor.columnSelected': '{index} de {total} columna/s seleccionada/s',
  'fabric.editor.columns': 'Diseños',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Insertar {numberOfColumns} columna igual} other {Insertar {numberOfColumns} columnas iguales}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Inserta un diseño de una sola columna',
  'fabric.editor.columns.description': 'Estructurar la página con secciones',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Se ha insertado una columna} other {Se han insertado {count} columnas}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Se ha eliminado la columna} other {Se han eliminado {count} columnas}}',
  'fabric.editor.configFailedToLoad': 'No se pudo cargar',
  'fabric.editor.configPanel.cancel': 'Cancelar',
  'fabric.editor.configPanel.close': 'Cerrar',
  'fabric.editor.configPanel.customSelect.createOption': 'Crear',
  'fabric.editor.configPanel.dateRange.custom.from': 'Desde',
  'fabric.editor.configPanel.dateRange.custom.to': 'a',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Contraer',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Ampliar',
  'fabric.editor.configPanel.dateRange.option.custom': 'Personalizar',
  'fabric.editor.configPanel.documentation': 'Documentación',
  'fabric.editor.configPanel.errorBoundary.note':
    'Se lo hemos dicho al equipo. Puedes seguir editando y publicar esta página, o consultar la consola de error para obtener más información.',
  'fabric.editor.configPanel.errorBoundary.title': 'Algo ha ido mal.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'No se puede combinar isMultiple con style: radio',
  'fabric.editor.configPanel.formType.addField': 'Añadir campo',
  'fabric.editor.configPanel.formType.removeField': 'Eliminar campo',
  'fabric.editor.configPanel.help': '¿Necesitas ayuda?',
  'fabric.editor.configPanel.invalid': 'Campo no válido',
  'fabric.editor.configPanel.required': 'Campo obligatorio',
  'fabric.editor.configPanel.submit': 'Enviar',
  'fabric.editor.contextPanel.panelLabel': 'Panel de contexto',
  'fabric.editor.copiedToClipboard': '¡Copiado!',
  'fabric.editor.copyToClipboard': 'Copiar',
  'fabric.editor.cornerControl': 'Destacar tabla',
  'fabric.editor.createComment': 'Comentar',
  'fabric.editor.createCommentDisabled':
    'Solo puedes comentar en texto, encabezados, emoticonos, fechas, menciones, enlaces y estados.',
  'fabric.editor.createCommentInvalid': 'Solo puedes comentar en el texto y los encabezados',
  'fabric.editor.customPanel': 'Panel personalizado',
  'fabric.editor.customPanel.description': 'Añade una nota con un emoticono y un fondo de color',
  'fabric.editor.datasource.assetsObjects.description':
    'Inserta objetos de Activos en Jira Service Management con las funciones de búsqueda y filtro',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Activos',
  'fabric.editor.datasource.confluenceSearch': 'Insertar lista de Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Inserta la lista de resultados de búsqueda de Confluence con las funciones de búsqueda, filtrado y configuración mejoradas.',
  'fabric.editor.datasource.jiraIssue': 'Incidencias de Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Inserta incidencias de Jira desde Jira Cloud con las funciones mejoradas de búsqueda, filtro y configuración.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Inserta actividades de Jira desde Jira Cloud con las funciones mejoradas de búsqueda, filtro y configuración.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Actividades de Jira',
  'fabric.editor.datasourceAppearanceTitle': 'Lista',
  'fabric.editor.datasourceTitle': 'Editar consulta de búsqueda',
  'fabric.editor.date': 'Fecha',
  'fabric.editor.date.description': 'Añadir una fecha usando un calendario',
  'fabric.editor.datePickerOpenedAlert':
    'Ventana emergente abierta del editor de fecha y ventana emergente de Pulsa la tecla de tabulación para acceder',
  'fabric.editor.decision': 'Decisión',
  'fabric.editor.decision.description': 'Captar decisiones para que sea más fácil supervisarlas',
  'fabric.editor.decisionPlaceholder': 'Añadir una decisión...',
  'fabric.editor.decreaseElementSize': 'Reducir el tamaño del elemento',
  'fabric.editor.decreaseSize': 'Reducir tamaño de tabla o elemento multimedia',
  'fabric.editor.defaultAltText': 'Documento',
  'fabric.editor.delete': 'Eliminar',
  'fabric.editor.description': 'Descripción',
  'fabric.editor.displayBlock': 'Mostrar como tarjeta',
  'fabric.editor.displayEmbed': 'Mostrar como objeto incrustado',
  'fabric.editor.displayInline': 'Mostrar insertado',
  'fabric.editor.displayLink': 'Mostrar como texto',
  'fabric.editor.displayOptionUnavailableInParentNode':
    'Esta opción de visualización no se encuentra disponible en {node}',
  'fabric.editor.displayText': 'Texto para mostrar',
  'fabric.editor.distributeColumns': 'Distribuir columnas',
  'fabric.editor.dragHandleZone': 'Activar zona de tirador para arrastrar',
  'fabric.editor.dropPlaceholderLabel': 'Documento',
  'fabric.editor.ecombedDescription': 'Mostrar una vista previa interactiva de un enlace',
  'fabric.editor.edit': 'Editar',
  'fabric.editor.edit.datasource': 'Editar consulta de búsqueda',
  'fabric.editor.edit.searchInput': 'Añadir un enlace',
  'fabric.editor.editAccessTitle': 'Acceso de edición requerido',
  'fabric.editor.editAltText': 'Editar texto alternativo',
  'fabric.editor.editDatasourceStandalone': 'Editar',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Editar consulta de búsqueda',
  'fabric.editor.editDateText': 'Editar fecha',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Editar consulta de búsqueda',
  'fabric.editor.editDropdownEditLinkTitle': 'Editar enlace',
  'fabric.editor.editDropdownExpandIconLabel': 'Ampliar el menú desplegable',
  'fabric.editor.editDropdownTriggerTitle': 'Editar',
  'fabric.editor.editLink': 'Editar enlace',
  'fabric.editor.editMode.inviteToEditButton.title': 'Invitar a editar',
  'fabric.editor.editStatusColor': 'Editar color de estado',
  'fabric.editor.editStatusText': 'Editar estado',
  'fabric.editor.editableContentLabel': 'Contenido editable',
  'fabric.editor.editorHelp': 'Ayuda del editor',
  'fabric.editor.editors': 'Editores',
  'fabric.editor.elementBrowser.help': 'Ayuda',
  'fabric.editor.elementInsertSidePanel.title': 'Insertar',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administración',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Todos',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Comunicación',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Contenido de Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Desarrollo',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Contenido externo',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formato',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Medios',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navegación',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Creación de informes',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Visuales e imágenes',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'Usa una pizarra para añadir elementos visuales a tu página',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'No hay nada que coincida con la búsqueda',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Intenta buscar con otro término o descubre nuevas aplicaciones para productos de Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Explorar Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {No hay nada que coincida con tu búsqueda.} one {{count} sugerencia disponible de forma predeterminada.} other {{count} sugerencias disponibles de forma predeterminada.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {No hay nada que coincida con tu búsqueda.} one {Hay {count} sugerencia disponible para texto escrito.} other {Hay {count} sugerencias disponibles para texto escrito.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Entrar',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Buscar',
  'fabric.editor.elementbrowser.sidebar.heading': 'Explorar',
  'fabric.editor.embedTitle': 'Integrar',
  'fabric.editor.embedToBlockCardWarning': 'Se muestra como una tarjeta en pantallas pequeñas',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Usa emojis para expresar ideas 🎉 y emociones 😄',
  'fabric.editor.emptyLink': 'Introduce un enlace.',
  'fabric.editor.emptySearchResults': 'No hemos podido encontrar ningún resultado.',
  'fabric.editor.emptySearchResultsSuggestion': 'Selecciona {buttonName} para ver las inserciones.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Error',
  'fabric.editor.errorPanel': 'Panel de errores',
  'fabric.editor.errorPanel.description': 'Resaltar los errores en un panel de color',
  'fabric.editor.expand': 'Ampliar',
  'fabric.editor.expand.description': 'Insertar una ampliación',
  'fabric.editor.expandAriaLabel': 'Indica un nombre para esta expansión',
  'fabric.editor.expandDefaultTitle': 'Haz clic aquí para ampliar...',
  'fabric.editor.expandNode': 'Ampliar contenido',
  'fabric.editor.expandPlaceholder': 'Indica un nombre para esta expansión...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Al eliminar la extensión {nodeName}, se interrumpirá todo lo que se haya conectado a ella.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Eliminando',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Eliminar',
  'fabric.editor.extension.deleteElementTitle': 'Eliminar elemento',
  'fabric.editor.extension.sourceNoTitledName': 'este elemento',
  'fabric.editor.extensions.config-panel.save-indicator': 'Todos los cambios se guardan siempre automáticamente',
  'fabric.editor.externalExtensionsHeading': 'Aplicaciones',
  'fabric.editor.externalMediaFile': 'Archivo multimedia externo',
  'fabric.editor.failed_to_upload': 'Error al cargar',
  'fabric.editor.feedbackDialog': 'Enviar comentarios',
  'fabric.editor.feedbackDialog.description': 'Cuéntanos tu experiencia con el editor en la nube',
  'fabric.editor.find': 'Buscar',
  'fabric.editor.findNext': 'Buscar siguiente',
  'fabric.editor.findPrevious': 'Buscar anterior',
  'fabric.editor.findReplaceToolbarButton': 'Buscar y reemplazar',
  'fabric.editor.fiveColumns': 'Diseño de 5 columnas',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Cancelar',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Eliminar también los elementos conectados',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 elemento conectado)} other {{name} (+{amount,number} elementos conectados)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': '¿Seguro?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'Aceptar',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer':
    'Se han abierto los controles de la barra de herramientas flotante',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Barra de herramientas flotante',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Opciones de diseño',
  'fabric.editor.floatingToolbar.scrollLeft': 'Desplazarse a la izquierda',
  'fabric.editor.floatingToolbar.scrollRight': 'Desplazarse a la derecha',
  'fabric.editor.focusTableResizeHandle': 'Controlador de cambio de tamaño de la tabla centrado',
  'fabric.editor.fourColumns': 'Diseño de 4 columnas',
  'fabric.editor.headerColumn': 'Columna de encabezado',
  'fabric.editor.headerRow': 'Fila de encabezado',
  'fabric.editor.heading1': 'Título 1',
  'fabric.editor.heading1Description': 'Úsalo en un título de nivel superior',
  'fabric.editor.heading2': 'Título 2',
  'fabric.editor.heading2Description': 'Úsalo en secciones clave',
  'fabric.editor.heading3': 'Título 3',
  'fabric.editor.heading3Description': 'Úsalo en subsecciones y títulos de agrupaciones',
  'fabric.editor.heading4': 'Título 4',
  'fabric.editor.heading4Description': 'Úsalo en títulos de varios niveles',
  'fabric.editor.heading5': 'Título 5',
  'fabric.editor.heading5Description': 'Úsalo para agrupar elementos de una lista',
  'fabric.editor.heading6': 'Título 6',
  'fabric.editor.heading6Description': 'Úsalo en títulos de nivel inferior',
  'fabric.editor.headingLink.ascOrderLabel': 'Ordenar columna de la Z a la A',
  'fabric.editor.headingLink.descOrderLabel': 'Borrar orden',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Error',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Incidencia',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Actividad',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Página',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Historia',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Tarea',
  'fabric.editor.headingLink.invalidLabel': '⚠️ No puedes ordenar una tabla con celdas combinadas',
  'fabric.editor.headingLink.noOrderLabel': 'Ordenar columna de la A a la Z',
  'fabric.editor.help': 'Ayuda',
  'fabric.editor.help.description': 'Navegar por todos los atajos de teclado y opciones de markdown',
  'fabric.editor.helpDialogTips': 'Pulsa {keyMap} para abrir este diálogo con rapidez en cualquier momento',
  'fabric.editor.highlight': 'Color de resaltado',
  'fabric.editor.highlight.removeColor': 'Quitar el color',
  'fabric.editor.highlightColor': 'Activar paleta de colores de resaltado',
  'fabric.editor.highlightFloatingToolbar': 'Destacar',
  'fabric.editor.horizontalRule': 'Divisor',
  'fabric.editor.horizontalRule.description': 'Separar el contenido con una línea horizontal',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Pegar o buscar el enlace',
  'fabric.editor.hyperlink.searchLinkAriaDescription':
    'Las sugerencias aparecerán abajo a medida que escribas en el campo',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {no hay resultados} one {{count,number} resultado encontrado} other {{count,number} resultados encontrados}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Texto que se muestra (opcional)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Pegar o buscar el enlace',
  'fabric.editor.image': 'Imagen',
  'fabric.editor.image.fullWidthLabel': 'Anchura completa',
  'fabric.editor.imageBorderBold': 'Negrita',
  'fabric.editor.imageBorderColor': 'Color',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Menú desplegable de colores para los bordes de la imagen',
  'fabric.editor.imageBorderMedium': 'Mediano',
  'fabric.editor.imageBorderOptions': 'Opciones de borde',
  'fabric.editor.imageBorderSize': 'Tamaño',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Menú desplegable de tamaños para los bordes de la imagen',
  'fabric.editor.imageBorderSubtle': 'Sutil',
  'fabric.editor.improvement': 'Mejora',
  'fabric.editor.increaseElementSize': 'Aumentar el tamaño del elemento',
  'fabric.editor.increaseSize': 'Reducir tamaño de tabla o elemento multimedia',
  'fabric.editor.indent': 'Aplicar sangría',
  'fabric.editor.info': 'Información',
  'fabric.editor.infoPanel': 'Panel de información',
  'fabric.editor.infoPanel.description': 'Destacar información en un panel de color',
  'fabric.editor.inlineConfigureLink': 'Configurar enlace',
  'fabric.editor.inlineDescription': 'Mostrar enlace como texto insertado',
  'fabric.editor.inlineGoToLink': 'Ir al enlace',
  'fabric.editor.inlineOverlay': 'Configurar',
  'fabric.editor.inlineTitle': 'Insertado',
  'fabric.editor.inputQueryAssistiveTxt':
    'Cuando aparezcan los resultados del rellenado automático, usa las flechas hacia arriba y hacia abajo para revisarlos, y pulsa Entrar para seleccionar uno. Toca los usuarios de dispositivos, explora con toques o gestos de deslizamiento.',
  'fabric.editor.insertColumn': 'Insertar columna a la derecha',
  'fabric.editor.insertColumnDrag': 'Insertar columna',
  'fabric.editor.insertMenu': 'Insertar elementos',
  'fabric.editor.insertRightRail.close': 'Cerrar',
  'fabric.editor.insertRightRail.title': 'Insertar',
  'fabric.editor.insertRow': 'Insertar fila debajo',
  'fabric.editor.insertRowDrag': 'Insertar fila',
  'fabric.editor.insertTableColumn': 'Insertar columna de tabla',
  'fabric.editor.insertTableRow': 'Insertar fila de tabla',
  'fabric.editor.invalidDateError': 'Introducir una fecha válida',
  'fabric.editor.invalidLink': 'Introduce un enlace válido.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Invita a un compañero de equipo a {productName}} trusted {Invita a un compañero de equipo a {productName}} other {Añade a un compañero de equipo a {productName}}}',
  'fabric.editor.italic': 'Cursiva',
  'fabric.editor.keyboardShortcuts': 'Métodos abreviados de teclado',
  'fabric.editor.layout.columnOption': '{count, plural, one {Columna} other {{count} columnas}}',
  'fabric.editor.layout.controls.placeholder': '/ para insertar',
  'fabric.editor.layout.placeholder': 'Añadir contenido',
  'fabric.editor.layout.resizeLayout': 'Redimensionar diseño',
  'fabric.editor.layoutFixedWidth': 'Volver a centrar',
  'fabric.editor.layoutFullWidth': 'Usar ancho completo',
  'fabric.editor.layoutStateFixedWidth': 'Centrado',
  'fabric.editor.layoutStateFullWidth': 'Ancho completo',
  'fabric.editor.layoutStateWide': 'Ancha',
  'fabric.editor.layoutWide': 'Usar formato ancho',
  'fabric.editor.leftSidebar': 'Diseño de la barra lateral izquierda',
  'fabric.editor.link': 'Vincular',
  'fabric.editor.link.description': 'Insertar un enlace',
  'fabric.editor.linkAddress': 'Dirección del enlace',
  'fabric.editor.linkPlaceholder': 'Pegar enlace',
  'fabric.editor.lists': 'Listas',
  'fabric.editor.listsFormat': 'Formato de lista',
  'fabric.editor.lockColumns': 'Anchuras de columna fijas',
  'fabric.editor.longEmptyNodePlaceholderText': 'Escribe / para insertar elementos',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Coincidir mayúsculas y minúsculas',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Ancho de multimedia reducido a {newMediaWidth,number} píxel.} other {Ancho de multimedia reducido a {newMediaWidth,number} píxeles.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Ancho de multimedia aumentado a {newMediaWidth,number} píxel.} other {Ancho de multimedia aumentado a {newMediaWidth,number} píxeles.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Medio reducido al tamaño mínimo',
  'fabric.editor.media.insert.cancel': 'Cancelar',
  'fabric.editor.media.insert.fileTabTitle': 'Fichero',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Lamentablemente, no se puede añadir este enlace a la imagen. Descarga la imagen y, a continuación, arrástrala y suéltala en la página.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Puede que esta imagen no esté visible para otras personas debido a restricciones de origen. Considera subir el archivo en su lugar.',
  'fabric.editor.media.insert.insert': 'Insertar',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Enlace no válido',
  'fabric.editor.media.insert.linkTabTitle': 'Enlace',
  'fabric.editor.media.insert.loadPreview': 'Cargar vista previa',
  'fabric.editor.media.insert.localFileErrorMessage': 'No se ha podido subir este archivo.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Se ha producido un error al subir el archivo. Comprueba la ruta del archivo o la red.',
  'fabric.editor.media.insert.mediaAlt': 'Vista previa del archivo de imagen o vídeo subido',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Selector de archivos multimedia',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Pegar enlace para subirlo',
  'fabric.editor.media.insert.upload': 'Cargar',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Medio aumentado al tamaño máximo',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Cambiar el tamaño',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Cerrar',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'entrada de altura',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Altura',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Anchura máxima {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Ancho',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Anchura máxima {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Convertir a píxeles',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migrar del tamaño porcentual a un tamaño de píxel fijo',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Enviar',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Error al validar el ancho',
  'fabric.editor.mediaAddLink': 'Añadir enlace',
  'fabric.editor.mediaFiles': 'Imagen, vídeo o archivo',
  'fabric.editor.mediaFiles.description': 'Añadir imágenes y otros archivos a la página',
  'fabric.editor.mediaGroupDeleteLabel': 'Eliminar',
  'fabric.editor.media_change_mediainline_caption_warn': 'En línea (se eliminará el pie de foto)',
  'fabric.editor.media_change_mediainline_default': 'Insertado',
  'fabric.editor.media_change_mediasingle': 'Tamaño original',
  'fabric.editor.mention': 'Mención',
  'fabric.editor.mention.description': 'Mencionar a alguien para enviarle una notificación',
  'fabric.editor.mentionNode.label': 'Usuario etiquetado',
  'fabric.editor.mentionsAddLabel': 'añadir-icono',
  'fabric.editor.mentionsIconLabel': 'Mención',
  'fabric.editor.mergeCells': 'Fusionar celdas',
  'fabric.editor.moreFormatting': 'Más formatos',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Mover columna a la izquierda} other {Mover columnas a la izquierda}}',
  'fabric.editor.moveColumnRight': '{0, plural, one {Mover columna a la derecha} other {Mover columnas a la derecha}}',
  'fabric.editor.moveDownDown': '{0, plural, one {Mover fila hacia abajo} other {Mover filas hacia abajo}}',
  'fabric.editor.moveRowUp': '{0, plural, one {Mover fila hacia arriba} other {Mover filas hacia arriba}}',
  'fabric.editor.navigate.toolbar.askAI': 'Preguntar a la IA',
  'fabric.editor.navigate.toolbar.editor': 'Ve a la barra de herramientas del editor',
  'fabric.editor.navigate.toolbar.floating': 'Ve a la barra de herramientas flotante',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {No tienes permiso para añadir comentarios en esta entrada de blog} page {No tienes permiso para añadir comentarios en esta página} other {No tienes permiso para añadir comentarios en esta página}}',
  'fabric.editor.noResultsFound': 'Sin resultados',
  'fabric.editor.noSearchResults': 'No hay resultados de búsqueda',
  'fabric.editor.normal': 'Texto normal',
  'fabric.editor.note': 'Nota',
  'fabric.editor.notePanel': 'Panel de notas',
  'fabric.editor.notePanel.description': 'Añadir una nota en un panel de color',
  'fabric.editor.numberedColumn': 'Columna numerada',
  'fabric.editor.off': '{formattingType} desactivado',
  'fabric.editor.on': '{formattingType} activado',
  'fabric.editor.openButtonTitle': 'Abrir',
  'fabric.editor.openCellOptions': 'Abrir opciones de celda',
  'fabric.editor.openLink': 'Abrir el enlace en otra pestaña',
  'fabric.editor.openPreviewPanel': 'Abrir panel de vista previa',
  'fabric.editor.orderedList': 'Lista numerada',
  'fabric.editor.orderedList.description': 'Crear una lista ordenada',
  'fabric.editor.other': 'Otros...',
  'fabric.editor.outdent': 'Anular sangría',
  'fabric.editor.overflowMenuViewMore': 'Ver más',
  'fabric.editor.pageActionsLabel': 'Acciones de la página',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Color de fondo',
  'fabric.editor.panel.custom': 'Personalizado',
  'fabric.editor.panel.emoji': 'Añadir emoji',
  'fabric.editor.panel.panelsGroup': 'Tipos de paneles',
  'fabric.editor.panelButtonTitle': 'Panel',
  'fabric.editor.pasteOptions': 'Opciones de pegado',
  'fabric.editor.pastePlainText': 'Pegar texto sin formato',
  'fabric.editor.placeholderAltText': 'Describir esta imagen con texto alternativo',
  'fabric.editor.placeholderText': 'Texto de marcador de posición',
  'fabric.editor.placeholderText.description': 'Insertar un marcador de posición de texto en la página',
  'fabric.editor.placeholderTextPlaceholder': 'Añadir texto de marcador de posición',
  'fabric.editor.plainText': 'Usar texto sin formato',
  'fabric.editor.preferencesLink': 'Preferencias de enlaces',
  'fabric.editor.previewButtonTitle': 'Vista previa',
  'fabric.editor.quickInsert': 'Inserción rápida',
  'fabric.editor.recordLoomShortTitle': 'Grabar',
  'fabric.editor.recordVideo': 'Grabar un vídeo de Loom',
  'fabric.editor.recordVideo.description': 'Graba y comparte tu pantalla y tus ideas',
  'fabric.editor.redo': 'Rehacer',
  'fabric.editor.remove': 'Eliminar',
  'fabric.editor.removeColumns': '{0, plural, one {Eliminar columna} other {Eliminar columnas}}',
  'fabric.editor.removeEmoji': 'Eliminar emoji',
  'fabric.editor.removeImageBorder': 'Eliminar borde',
  'fabric.editor.removeRows': '{0, plural, one {Eliminar fila} other {Eliminar filas}}',
  'fabric.editor.replace': 'Reemplazar',
  'fabric.editor.replaceAll': 'Reemplazar todo',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} coincidencia reemplazada} other {{numberOfMatches,number} coincidencias reemplazadas}}',
  'fabric.editor.replaceWith': 'Reemplazar por',
  'fabric.editor.requestToEdit': 'Solicitar para editar',
  'fabric.editor.requestToEditDescription':
    'Cuando solicites el acceso, el propietario de la página recibirá una notificación.',
  'fabric.editor.requestToEditDismiss': 'Descartar',
  'fabric.editor.resizeHandle': 'Controlador de cambio de tamaño',
  'fabric.editor.resultsCount': '{selectedMatchPosition} de {totalResultsCount}',
  'fabric.editor.richText': 'Usar texto enriquecido',
  'fabric.editor.rightSidebar': 'Diseño de la barra lateral derecha',
  'fabric.editor.rowControl': 'Destacar fila',
  'fabric.editor.rowDragHandle': 'Opciones de fila',
  'fabric.editor.rowMovedDown': 'Fila movida hacia abajo a {index} de {total}',
  'fabric.editor.rowMovedUp': 'Fila movida hacia arriba a {index} de {total}',
  'fabric.editor.rowSelected': '{index} de {total} fila/s seleccionada/s',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Se ha insertado una fila} other {Se han insertado {count} filas}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Se ha eliminado la fila} other {Se han eliminado {count} filas}}',
  'fabric.editor.saveButton': 'Guardar',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} resultado de búsqueda disponible. Usa las teclas de flecha arriba y abajo para navegar entre las opciones. Pulsa Intro para seleccionar una opción.} other {{itemsLength,number} resultados de búsqueda disponible. Usa las teclas de flecha arriba y abajo para navegar entre las opciones. Pulsa Intro para seleccionar una opción.}}',
  'fabric.editor.selectColumnResize': 'Selecciona la opción para cambiar el tamaño de la columna',
  'fabric.editor.selectLanguage': 'Seleccionar lenguaje',
  'fabric.editor.selectTableColumn': 'Selecciona la columna de la tabla',
  'fabric.editor.selectTableRow': 'Selecciona la fila de la tabla',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Seleccionar aplicación',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': 'Más opciones',
  'fabric.editor.settingsLinks': 'Ir a Preferencias de enlaces',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ para insertar',
  'fabric.editor.shortcut': 'Atajo de texto',
  'fabric.editor.single': 'Diseño de columna única',
  'fabric.editor.singleColumns': 'Diseño de 1 columna',
  'fabric.editor.sortColumnASC': 'Ordenar columna A → Z',
  'fabric.editor.sortColumnDESC': 'Ordenar columna Z → A',
  'fabric.editor.sortColumnDecreasing': 'Ordenar en descendente',
  'fabric.editor.sortColumnIncreasing': 'Ordenar en ascendente',
  'fabric.editor.splitCell': 'Dividir celda',
  'fabric.editor.status': 'Estado',
  'fabric.editor.status.description': 'Añadir una etiqueta de estado personalizada',
  'fabric.editor.statusEditorLabel': 'Editor de estados',
  'fabric.editor.statusPickerOpenedAlert':
    'Se ha abierto la ventana del editor de estado, pulsa la tecla de tabulación para acceder a la ventana emergente',
  'fabric.editor.statusPlaceholder': 'Establecer un estado',
  'fabric.editor.story': 'Historia',
  'fabric.editor.strike': 'Tachado',
  'fabric.editor.subTask': 'Subtarea',
  'fabric.editor.subscript': 'Subíndice',
  'fabric.editor.subscript.off.superscript.on': 'Subíndice desactivado, superíndice activado',
  'fabric.editor.success': 'Correcto',
  'fabric.editor.successPanel': 'Panel de contenido correcto',
  'fabric.editor.successPanel.description': 'Añadir consejos en un panel de color',
  'fabric.editor.superscript': 'Superíndice',
  'fabric.editor.superscript.off.subscript.on': 'Superíndice desactivado, subíndice activado',
  'fabric.editor.supportAltText':
    'El texto alternativo es útil para aquellas personas que utilicen lectores de pantalla debido a limitaciones visuales.',
  'fabric.editor.table': 'Tabla',
  'fabric.editor.table.description': 'Insertar una tabla',
  'fabric.editor.tableAlignmentOptions': 'Opciones de alineación',
  'fabric.editor.tableFullWidthLabel': 'Anchura completa',
  'fabric.editor.tableHeader.sorting.asc': 'Se ha aplicado el orden ascendente',
  'fabric.editor.tableHeader.sorting.default': 'Ordenar la columna',
  'fabric.editor.tableHeader.sorting.desc': 'Se ha aplicado el orden descendente',
  'fabric.editor.tableHeader.sorting.invalid': 'No puedes ordenar una tabla con celdas combinadas',
  'fabric.editor.tableHeader.sorting.no': 'No hay ningún orden aplicado a la columna',
  'fabric.editor.tableOptions': 'Opciones de tabla',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Ancho de la tabla reducido a {newWidth,number} píxel.} other {Ancho de la tabla reducido a {newWidth,number} píxeles.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Ancho de la tabla aumentado a {newWidth,number} píxel.} other {Ancho de la tabla aumentado a {newWidth,number} píxeles.}}',
  'fabric.editor.tableScrollRegion': 'Región de desplazamiento de la tabla',
  'fabric.editor.tableSelector': 'Tamaño de tabla',
  'fabric.editor.tableSelector.description':
    'Añade una tabla mediante la ventana emergente para seleccionar un tamaño personalizado',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} de {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Selector de tamaño de tabla',
  'fabric.editor.tables.adjustColumn': 'Ajustar columna',
  'fabric.editor.tables.columnResizeLast': 'Solo puedes cambiar el tamaño de la columna hacia la izquierda.',
  'fabric.editor.tables.columnResizeOverflow':
    'Solo puedes cambiar el tamaño de la columna mientras la tabla tiene una barra de desplazamiento.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Ancho de columna cambiado a {width} píxel} other {Ancho de columna cambiado a {width} píxeles}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Al eliminar la extensión {nodeName}, se interrumpirá todo lo que se haya conectado a ella.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Eliminar',
  'fabric.editor.tables.resizeStop': 'Cambio de tamaño detenido',
  'fabric.editor.tables.resizeTable': 'Cambiar tamaño de tabla',
  'fabric.editor.tables.startedColumnResize': 'Cambio de tamaño de la columna comenzado',
  'fabric.editor.task': 'Tarea',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Marcar tarea como completada',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Marcar tarea como no completada',
  'fabric.editor.taskList': 'Lista de tareas',
  'fabric.editor.taskPlaceholder': 'Escribe la acción y usa "@" para asignársela a alguien.',
  'fabric.editor.text.formatting.off': 'Formato de texto desactivado',
  'fabric.editor.textColor': 'Color de texto {selectedColorName}',
  'fabric.editor.textColorHighlightTooltip': 'Color de texto y resaltado',
  'fabric.editor.textColorTooltip': 'Color del texto',
  'fabric.editor.textFormat': 'Dar formato al texto',
  'fabric.editor.textFormatting': 'Formato de texto',
  'fabric.editor.textStyles': 'Estilos de texto {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Estilos de texto',
  'fabric.editor.threeColumns': 'Diseño de 3 columnas',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Tres columnas con diseño de barra lateral izquierda',
  'fabric.editor.threeColumnsWithRightSidebars': 'Tres columnas con diseño de barra lateral derecha',
  'fabric.editor.threeColumnsWithSidebars': 'Tres columnas con diseño de barras laterales',
  'fabric.editor.time.ago': 'antes',
  'fabric.editor.time.updated': 'Actualizado',
  'fabric.editor.time.viewed': 'Visto',
  'fabric.editor.toolbarAppears': 'Aparece la barra de herramientas',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Añadir imagen, vídeo o archivo',
  'fabric.editor.toolbarPositionFixedAtTop': 'Fijo en la parte superior',
  'fabric.editor.toolbarPositionInline': 'En línea con el texto',
  'fabric.editor.toolbarPositionPinedAtTop': 'Desanclar la barra de herramientas',
  'fabric.editor.toolbarPositionUnpined': 'Anclar la barra de herramientas en la parte superior',
  'fabric.editor.toolbarPositionUnpinnedConcise': 'Anclar la barra de herramientas en la parte superior',
  'fabric.editor.tooltip.blockPanel': 'un panel',
  'fabric.editor.tooltip.bulletList': 'una lista',
  'fabric.editor.tooltip.decisionList': 'una lista de decisiones',
  'fabric.editor.tooltip.defaultBlockNode': 'un nodo de bloqueo',
  'fabric.editor.tooltip.nestedExpand': 'una expansión anidada',
  'fabric.editor.tooltip.taskList': 'un elemento de acción',
  'fabric.editor.turnInto': 'Convertir en',
  'fabric.editor.twoColumns': 'Diseño de 2 columnas',
  'fabric.editor.typeAhead.popupLabel': 'Resultados de escritura predictiva',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'Comienza a escribir para buscar o filtrar opciones de atajos de teclado',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Buscar',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Atajos de teclado para inserciones y formato',
  'fabric.editor.typeAheadErrorFallbackDescription': 'No hay resultados disponibles. Vuelve a intentarlo.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Se ha producido un error',
  'fabric.editor.typeahead.emojiInputLabel': 'Comienza a escribir para buscar o filtrar opciones de emoticonos',
  'fabric.editor.typeahead.emojiListItemLabel': 'Texto del atajo de teclado para el emoticono {name}: {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Atajos de teclado para emoticonos',
  'fabric.editor.typeahead.mentionInputLabel': 'Comienza a escribir para buscar usuarios que etiquetar',
  'fabric.editor.typeahead.mentionPopupLabel': 'Usuarios a los que puedes etiquetar',
  'fabric.editor.typeahead.metionListItemLabel': 'Usuario {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'No hemos podido cargar este contenido',
  'fabric.editor.unableToOpenLink': 'No se puede abrir este enlace',
  'fabric.editor.underline': 'Subrayado',
  'fabric.editor.undo': 'Deshacer',
  'fabric.editor.unknown.label': 'Desconocido',
  'fabric.editor.unlink': 'Desvincular',
  'fabric.editor.unorderedList': 'Lista de viñetas',
  'fabric.editor.unorderedList.description': 'Crear una lista sin ordenar',
  'fabric.editor.unsupportedBlockContent': 'Este editor no permite mostrar este contenido.',
  'fabric.editor.unsupportedContentTooltip':
    'El contenido no está disponible en este editor, se conservará cuando edites y guardes.',
  'fabric.editor.unsupportedInlineContent': 'Contenido no admitido',
  'fabric.editor.upDown':
    'Al utilizar las teclas de flecha hacia arriba y hacia abajo en el siguiente campo de entrada, la fecha se actualizará a continuación',
  'fabric.editor.url': 'Mostrar URL',
  'fabric.editor.urlDescription': 'Mostrar enlace como URL',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Usa Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Ver y añadir comentarios',
  'fabric.editor.viewCommentOnMedia': 'Ver comentarios',
  'fabric.editor.viewMore': 'Ver más',
  'fabric.editor.viewMoreAriaLabel': 'Ver todos los elementos',
  'fabric.editor.visit': 'Abrir el enlace en otra ventana',
  'fabric.editor.warning': 'Advertencia',
  'fabric.editor.warningPanel': 'Panel de advertencias',
  'fabric.editor.warningPanel.description': 'Añadir una nota de precaución en un panel de color',
  'fabric.editor.wrapLeft': 'Ajustar a la izquierda',
  'fabric.editor.wrapRight': 'Ajustar a la derecha',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Azul',
  'fabric.theme.bold-blue': 'Azul intenso',
  'fabric.theme.bold-gray': 'Gris intenso',
  'fabric.theme.bold-green': 'Verde intenso',
  'fabric.theme.bold-magenta': 'Magenta intenso',
  'fabric.theme.bold-orange': 'Naranja intenso',
  'fabric.theme.bold-purple': 'Morado intenso',
  'fabric.theme.bold-red': 'Rojo intenso',
  'fabric.theme.bold-teal': 'Verde azulado intenso',
  'fabric.theme.bold-yellow': 'Amarillo oscuro',
  'fabric.theme.bolder-blue': 'Azul más intenso',
  'fabric.theme.bolder-gray': 'Gris más intenso',
  'fabric.theme.bolder-green': 'Verde más intenso',
  'fabric.theme.bolder-magenta': 'Magenta más intenso',
  'fabric.theme.bolder-orange': 'Naranja más intenso',
  'fabric.theme.bolder-purple': 'Morado más intenso',
  'fabric.theme.bolder-red': 'Rojo más intenso',
  'fabric.theme.bolder-teal': 'Verde azulado más intenso',
  'fabric.theme.bolder-yellow': 'Amarillo más intenso',
  'fabric.theme.dark-blue': 'Azul oscuro',
  'fabric.theme.dark-gray': 'Gris oscuro',
  'fabric.theme.dark-green': 'Verde oscuro',
  'fabric.theme.dark-purple': 'Morado oscuro',
  'fabric.theme.dark-red': 'Rojo oscuro',
  'fabric.theme.dark-teal': 'Verde azulado oscuro',
  'fabric.theme.dark-yellow': 'Amarillo oscuro',
  'fabric.theme.default': 'Predeterminado',
  'fabric.theme.gray': 'Gris',
  'fabric.theme.green': 'Verde',
  'fabric.theme.light-blue': 'Azul claro',
  'fabric.theme.light-gray': 'Gris claro',
  'fabric.theme.light-green': 'Verde claro',
  'fabric.theme.light-purple': 'Morado claro',
  'fabric.theme.light-red': 'Rojo claro',
  'fabric.theme.light-teal': 'Verde azulado claro',
  'fabric.theme.light-yellow': 'Amarillo claro',
  'fabric.theme.lime': 'Lima',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Sin resaltado',
  'fabric.theme.orange': 'Naranja',
  'fabric.theme.purple': 'Morado',
  'fabric.theme.red': 'Rojo',
  'fabric.theme.subtle-blue': 'Azul sutil',
  'fabric.theme.subtle-gray': 'Gris sutil',
  'fabric.theme.subtle-green': 'Verde sutil',
  'fabric.theme.subtle-magenta': 'Magenta sutil',
  'fabric.theme.subtle-orange': 'Naranja sutil',
  'fabric.theme.subtle-purple': 'Morado sutil',
  'fabric.theme.subtle-red': 'Rojo sutil',
  'fabric.theme.subtle-teal': 'Verde azulado sutil',
  'fabric.theme.subtle-yellow': 'Amarillo sutil',
  'fabric.theme.teal': 'Verde azulado',
  'fabric.theme.white': 'Blanco',
  'fabric.theme.yellow': 'Amarillo',
  'fabrid.editor.rowNumbers': 'Números de fila',
  'rovo.agents.dropdown.title': 'Agentes',
  'rovo.agents.dropdown.viewAgents.label': 'Ver todos los agentes',
};
